// src/data/sidebar_config.js

/**
 * Single source of truth for sidebar UI per role/app.
 * - role_key: normalized role name from user profile (lowercase, underscores)
 * - app_key: which portal/module is active (fund_manager, donor_portal, governance, entrepreneur)
 */

export const SIDEBAR_CONFIG = {
  fund_manager: {
    header_title: "Gauteng Water Command Centre",

    menu: [
      { key: "executive-overview", label: "Gauteng Water Command Centre", audience: "Premier, Minister, DWS, PWSG", icon: "bi bi-house-door-fill" },
      { key: "executive-metro-performance", label: "Executive Metro Performance", audience: "DWS, metros, Rand Water", icon: "bi bi-bar-chart-line-fill" },
      { key: "operational-reservoir-supply", label: "Operational Reservoir & Supply", audience: "engineers/operators", icon: "bi bi-droplet-fill" },
      { key: "leaks-bursts-nrw", label: "Leaks, Bursts & NRW", audience: "utilities, CFOs, operations", icon: "bi bi-activity" },
      { key: "infrastructure-risk-maintenance", label: "Infrastructure Risk & Maintenance", audience: "technical executives", icon: "bi bi-tools" },
      { key: "demand-management-behaviour", label: "Demand Management & Behaviour", audience: "metros, comms teams", icon: "bi bi-graph-up-arrow" },
      { key: "public-trust-citizen-view", label: "Public Trust & Citizen View", audience: "public/civil society", icon: "bi bi-shield-fill-check" },
      { key: "incident-emergency-response", label: "Incident & Emergency Response", audience: "command teams", icon: "bi bi-exclamation-triangle-fill" },
      { key: "water-quality-public-health", label: "Water Quality & Public Health", audience: "DWS, health, metros", icon: "bi bi-heart-pulse-fill" },
      { key: "financial-sustainability", label: "Financial Sustainability", audience: "CFOs, Treasury", icon: "bi bi-file-earmark-text-fill" },
      { key: "programme-delivery-interventions", label: "Programme Delivery & Interventions", audience: "PWSG, GIZ, SALGA, WRG", icon: "bi bi-wrench-adjustable" },
      { key: "climate-forecasting-scenario-planning", label: "Climate, Forecasting & Scenario Planning", audience: "strategy teams", icon: "bi bi-gear-fill" }
    ],

    include_programmes_component: false
  },

  donor_portal: {
    header_title: "Donor",
    menu: [
      { key: "impact-dashboard", label: "My Impact Dashboard", icon: "bi bi-grid" },
      { key: "ssin-portfolio", label: "SSIN Portfolio", icon: "bi bi-file-earmark-text" },
      { key: "adopted-assets", label: "My Adopted Assets", icon: "bi bi-gift" },
      { key: "impact-reports", label: "Impact Reports", icon: "bi bi-bullseye" },
      { key: "financials-tax", label: "Financials & Tax", icon: "bi bi-receipt" },
      { key: "documents", label: "Documents", icon: "bi bi-folder2-open" }
    ],
    include_programmes_component: false
  },

  governance: {
    header_title: "Governance",
    menu: [
      { key: "governance-overview", label: "Governance Overview", icon: "bi bi-grid" },
      { key: "risk-management", label: "Risk Management", icon: "bi bi-exclamation-triangle" },
      { key: "audit-findings", label: "Audit & Findings", icon: "bi bi-file-earmark-text" },
      { key: "compliance", label: "Compliance", icon: "bi bi-scales" },
      { key: "controls", label: "Controls", icon: "bi bi-gear" },
      { key: "board-management", label: "Board Management", icon: "bi bi-people" }
    ],
    include_programmes_component: false
  },

  entrepreneur: {
    header_title: "Entrepreneur",
    menu: [
      { key: "my-business", label: "My Business", icon: "bi bi-briefcase" },
      { key: "earnings-payouts", label: "Earnings & Payouts", icon: "bi bi-cash-stack", badge: "Soon" },
      { key: "training-certs", label: "Training & Certs", icon: "bi bi-mortarboard", badge: "Soon" },
      { key: "maintenance", label: "Maintenance", icon: "bi bi-gear", badge: "Soon" },
      { key: "support", label: "Support", icon: "bi bi-question-circle", badge: "Soon" }
    ],
    include_programmes_component: false
  }
};

/**
 * Map normalized role names to sidebar config keys.
 * Example: "Fund Manager" -> "fund_manager"
 */
export const ROLE_TO_APP_KEY = {
  fund_manager: "fund_manager",
  donor: "donor_portal",
  governance: "governance",
  entrepreneur: "entrepreneur"
};
